import angular from "angular";

angular
	.module('app')
	.component('uploadAudio', {
		template: require('./upload-audio.html'),
        controller: ['Upload', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(Upload) {

	let $ctrl = this;
	$ctrl.audio = null;
	$ctrl.invalidAudio = null;

    $ctrl.save = function () {
        $ctrl.close({
            $value: $ctrl.audio
        });
    };
}
